import { render, staticRenderFns } from "./VersionsTabs.vue?vue&type=template&id=08f636c4&scoped=true"
import script from "./VersionsTabs.vue?vue&type=script&lang=js"
export * from "./VersionsTabs.vue?vue&type=script&lang=js"
import style0 from "./VersionsTabs.vue?vue&type=style&index=0&id=08f636c4&prod&lang=css"
import style1 from "./VersionsTabs.vue?vue&type=style&index=1&id=08f636c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f636c4",
  null
  
)

export default component.exports